export const commentsValueList = {
	Bonus: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Delay Filing", label: "Delay Filing" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	EPF: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Delay Filing", label: "Delay Filing" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	ESIC: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Delay Filing", label: "Delay Filing" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	PTAX: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Delay Filing", label: "Delay Filing" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	Wages: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Delay Filing", label: "Delay Filing" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	NFH: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Not Paid", label: "Not Paid" },
	],
	MWA: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Not Paid", label: "Not Paid" },
	],

	CLRA: [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Not Paid", label: "Not Paid" },
		{ value: "Delay Submission", label: "Delay Submission" },
	],
	"WC Policy": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{ value: "Expired", label: "Expired" },
	],

	"Holiday list": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Delay Submission", label: "Delay Submission" },
		{
			value: "Uploaded other state holiday list",
			label: "Uploaded other state holiday list",
		},
		{ value: "Delay in submission ", label: "Delay in submission " },
	],
	"Bank Statement": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Delay in Salary", label: "Delay in Salary" },
		{ value: "Not Uploaded", label: "Not Uploaded" },
	],
	"Leave Register": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Not Uploaded", label: "Not Uploaded" },
	],
	"In & Out Register": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{ value: "Not Uploaded", label: "Not Uploaded" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
	],
	"Muster Roll cum Wage Register": [
		{ value: "Multiple NC", label: "Multiple NC" },
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Delay in Salary", label: "Delay in Salary" },
	],
	"Workmen Register": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Delay in Salary", label: "Delay in Salary" },
	],
	"Wage Slip": [
		{ value: "Wrong Upload", label: "Wrong Upload" },
		{
			value: "Register error/incomplete document",
			label: "Register error/incomplete document",
		},
		{ value: "Delay in Salary", label: "Delay in Salary" },
	],
};

export const commentsTitleList = [
	{ value: "Bonus", label: "Bonus" },
	{ value: "EPF", label: "EPF" },
	{ value: "ESIC", label: "ESIC" },
	{ value: "PTAX", label: "PTAX" },
	{ value: "Wages", label: "Wages" },
	{ value: "NFH", label: "NFH" },
	{ value: "MWA", label: "MWA" },
	{ value: "CLRA", label: "CLRA" },
	{ value: "WC Policy", label: "WC Policy" },
	{ value: "Holiday list", label: "Holiday list" },
	{ value: "Bank Statement", label: "Bank Statement" },
	{ value: "Leave Register", label: "Leave Register" },
	{ value: "In & Out Register", label: "In & Out Register" },
	{
		value: "Muster Roll cum Wage Register",
		label: "Muster Roll cum Wage Register",
	},
	{ value: "Workmen Register", label: "Workmen Register" },
	{ value: "Wage Slip", label: "Wage Slip" },
];
// {value:'',label:''}
